export type FirestoreBrowserIdentity = {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
};

function isWebKitBrowser({
  userAgent,
  platform,
  maxTouchPoints,
}: FirestoreBrowserIdentity) {
  const isIos =
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === 'MacIntel' && maxTouchPoints > 1);
  const isSafariWebKit = /^((?!chrome|android|crios|fxios).)*safari/i.test(
    userAgent,
  );

  return isIos || isSafariWebKit;
}

/**
 * WebKit 26.4 can hold Firestore fetch-stream completion frames until the
 * backend's 30-second keep-alive arrives. Keep fetch streams for other engines
 * and route WebKit through Firestore's long-polling XHR transport until the
 * browser bug is fixed upstream.
 */
export function shouldUseFirestoreFetchStreams(
  browser: FirestoreBrowserIdentity | undefined = typeof window === 'undefined'
    ? undefined
    : {
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
        maxTouchPoints: window.navigator.maxTouchPoints,
      },
) {
  return browser ? !isWebKitBrowser(browser) : false;
}
